export default "__VITE_ASSET__DMFzhdkN__"